export interface LoanRequest {
    amount?: number
    appName?: string
    cameraId?: number
    cancelTime?: string
    contractAmount?: number
    contractTemplateId?: number
    createTime?: string
    current?: number
    customerId?: number
    did?: number
    endReleaseTime?: string
    feeAmount?: number
    finishTime?: string
    haircutAmount?: number
    interest?: number
    lid?: number
    loanCycle?: number
    loanCycleUnit?: number
    paidType?: number
    productId?: number
    productVersion?: string
    rate?: number
    releaseTime?: string
    riskLevel?: string
    size?: number
    startReleaseTime?: string
    state?: number
    tenantId?: number
    tradeEndTime?: number
    tradeStartTime?: string
    updateTime?: string
    customerName?: string
    phone?: string
    cardNo?: string
}

export interface LoanResponse {
    amount: number
    bankCard: string
    bankName: string
    cameraId: number
    cancelTime: string
    cardNo: string
    contractAmount: number
    contractTemplateId: number
    createTime: string
    customerId: number
    customerName: string
    did: number
    feeAmount: number
    finishTime: string
    haircutAmount: number
    interest: number
    lid: number
    loanCycle: number
    loanCycleUnit: number
    paidType: number
    productId: number
    productName: string
    productVersion: string
    rate: number
    releaseTime: string
    remark: string
    riskLevel: string
    state: number
    tenantId: number
    tradeEndTime: string
    tradeStartTime: string
    updateTime: string
    rateType: number
    cameraIdStr: string
}

export enum LoanState {
    INIT,
    LENDING,
    FINISH,
    WRITEOFF,
    CANCEL,
    FAIL,
    REFUSE,
    TRANSACTION
}

export enum LoanCycleUnit {
    MONTH,
    DAY
}

export enum LoanRateType {
    DAY = 100,
    MONTH = 2,
    YEAR = 1
}

export interface CancelLoanRequest {
    lid: number
    tenantId?: number
}

export interface QueryLoanInfoRequest {
    lid: number
    tenantId?: number
}

export interface loanReviewWequest {
    lids: string
    remark: string
    review: boolean
}

export interface LoanReviewResponse {
    msg: string
    success: boolean
}
